import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGradientRing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 282,
	height: 282,
	viewBox: "0 0 282 282",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M141 281.288C63.5215 281.288 0.712555 218.479 0.712555 141.001C0.712555 63.5219 63.5215 0.712891 141 0.712891C218.479 0.712891 281.288 63.5219 281.288 141.001C281.288 218.479 218.479 281.288 141 281.288ZM141 272.871C68.1702 272.871 9.12973 213.831 9.12973 141.001C9.12973 68.1707 68.1702 9.13029 141 9.13029C213.83 9.13029 272.871 68.1707 272.871 141.001C272.871 213.831 213.83 272.871 141 272.871Z",
		fill: "url(#paint0_linear_4624_289856)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_4624_289856",
		x1: 280.557,
		y1: 108.302,
		x2: 37.8032,
		y2: 262.19,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4739EE" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#AC0086"
		})]
	}) })]
});
export default SvgGradientRing;
